<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline mb-4">
            {{ $t('fines.title') }} - {{ autoTitle }}
          </h1>
        </v-flex>
      </v-layout>
    </v-flex>

    <fines-table class="mt-4" :car-id="$route.params.autoId" simple />
  </v-layout>
</template>

<script>
// import store from '@/store';
// import hasPermission from '@/helpers/hasPermission';
import FinesTable from '../../components/fines/FinesTable.vue';

export default {
  components: { FinesTable },
  // beforeRouteEnter(to, from, next) {
  //   const isInvestor = store.getters['global/getRole'] === 'investor';
  //   const can = hasPermission('car_view');

  //   if (isInvestor && !can) next('/investor-board');
  //   else next();
  // },
  computed: {
    autoTitle() {
      return this.$store.getters['auto/getAutoTitle'];
    },
  },
};
</script>

<style></style>
